export const tips = [
  'Understand what your actual business credit score is and the factors which are impacting how it is calculated.',
  'A better consultation from a funding specialist using your Experian business credit file, as used by banks and lenders.',
  'Your application prioritised and fast-tracked by our funding team.',
  'Protect your business credit profile from a hard lender check.',
];
